import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { getCookie } from "../../../slidebar/components/DarkMode";
import { shallowEqual, useSelector } from "react-redux";
import { PromotionItem } from "./PromotionItem";

export const PromotionListDialog = ({
  setShow,
  show,
  setFieldValue,
  promotionid,
}) => {
  const intl = useIntl();
  const memberState = useSelector(({ member }) => member, shallowEqual);
  const [mode, setMode] = useState(getCookie("selectedTheme"));

  const handleClose = () => setShow(false);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        data-bs-theme={mode}
        className="zIndex-9999"
        backdropClassName="zIndex-9999"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "promotion",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {memberState.memberGameBalance?.promotionListsV2.map((promo) => (
            <PromotionItem
              key={promo.promotionid}
              promo={promo}
              className={
                promotionid === promo.promotionid ? "border-warning shadow" : ""
              }
              onClick={() => {
                setFieldValue(
                  "promotionid",
                  promotionid !== promo.promotionid ? promo.promotionid : ""
                );
                setShow(false);
              }}
            />
          ))}
          {memberState.memberGameBalance &&
            memberState.memberGameBalance?.promotionListsV2.length <= 0 && (
              <div className="text-center p-4">
                {intl.formatMessage({ id: "noRecordFound" })}
              </div>
            )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
